import { Injectable } from '@angular/core';
import { ServerService } from '../services/server.service';
import { Property, Amenities, PropertyImages, PropertyType } from './property.model';
import { Consultant } from '../agentes/consultant.model';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
  private property: Property[];
  private amenities: Amenities[];

  constructor(private _server: ServerService) { }

  getPropertys(): Promise<Property[]> {
    return new Promise((resolve, reject) => {
      this.allPropertys().then(
        () => {
          const property: Property[] = JSON.parse(localStorage.getItem('Properties'));
          resolve(property);
        }, () => {
          const property: Property[] = [];
          reject(property);
        }
      );
    });
  }

  getProperty(id: number): Promise<Property> {
    return new Promise((resolve, reject) => {
      this._server.getServer('Properties/' + id).then(
        (resp: any) => {
          resolve(resp);
        }, (err: any) => {
          reject(err);
        }
      );
    });
  }

  getAmenitiesProperty(id: number): Promise<Property> {
    return new Promise((resolve, reject) => {
      this._server.getServer('AmenitiesProperties/' + id).then(
        (resp: any) => {
          resolve(resp);
        }, (err: any) => {
          reject(err);
        }
      );
    });
  }

  allPropertys(): Promise<Property[]> {
    return new Promise((resolve, reject) => {
      this._server.getServer('Properties').then(
        (resp: any[]) => {
          this.property = resp;
          resolve(resp);
        }, (err: any) => {
          reject();
        }
      );
    });
  }

  allPropertysRealEstate(id: number): Promise<Property[]> {
    return new Promise((resolve, reject) => {
      this._server.getServer('indexProperties/' + id).then(
        (resp: any[]) => {
          this.property = resp;
          resolve(resp);
        }, (err: any) => {
          reject();
        }
      );
    });
  }

  allPropertysAgent(): Promise<Property[]> {
    return new Promise((resolve, reject) => {
      this._server.getServer('indexPropertiesAgent').then(
        (resp: any[]) => {
          this.property = resp;
          resolve(resp);
        }, (err: any) => {
          reject();
        }
      );
    });
  }

  allPropertiesTypes(): Promise<PropertyType[]> {
    return new Promise((resolve, reject) => {
      this._server.getServer('propertyTypes').then(
        (resp: PropertyType[]) => {
          resolve(resp);
        }, (err: any) => {
          reject(err);
        }
      );
    });
  }

  getAmenities(): Promise<Amenities[]> {
    return new Promise((resolve, reject) => {
      this.allAmenities().then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  getAgentsRealEstate(id: number): Promise<Consultant[]> {
    return new Promise((resolve, reject) => {
      this._server.getServer('indexAgentsRE/' + id).then(
        (resp: any) => {
          resolve(resp);
        }, (err: any) => {
          reject();
        }
      );
    });
  }

  allAmenities(): Promise<Amenities> {
    return new Promise((resolve, reject) => {
      this._server.getServer('amenities').then(
        (resp: any) => {
          resolve(resp);
        }, (err: any) => {
          reject(err);
        }
      );
    });
  }



  setFavoAgent(idProperty: number, idUser: number = null): Promise<any> {
    return new Promise((resolve, reject) => {
      const env = {
        propertyId: idProperty,
        agentId: idUser,
      };
      this._server.postServer('setFavorite', env).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  saveChangesPropertyDelete(dateChange): Promise<any> {
    return new Promise((resolve, reject) => {
      this._server.postServer('saveProfilingWeb', dateChange).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }


  saveNoPublicityProperty(dateChange): Promise<any> {
    return new Promise((resolve, reject) => {
      this._server.postServer('saveNoPublicityProperty', dateChange).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  saveNotificationDisable(dateChange): Promise<any> {
    return new Promise((resolve, reject) => {
      this._server.postServer('saveNotificationDisable', dateChange).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }


  addProperty(property: Property): Promise<Property> {
    return new Promise((resolve, reject) => {
      this._server.postServer('Properties', property).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  ordenImages(imgs: any): Promise<Property> {
    return new Promise((resolve, reject) => {
      this._server.postServer('PropertyImagesOrder', imgs).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  updateProperty(property: Property): Promise<Property> {
    return new Promise((resolve, reject) => {
      this._server.putServer('Properties/' + property.id, property).then(
        (resp: Property) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  deleteProperty(id: number): Promise<void> {
    return new Promise((resolve, reject) => {

      this._server.deleteServer('Properties/' + id).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  disableProperty(id: number): Promise<void> {
    return new Promise((resolve, reject) => {
      this._server.getServer('enableDisable/' + id).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  uploadFile(file: PropertyImages, id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      const input = new FormData();
      this._server.postFileData('PropertyImages/' + id, file, file.image).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  deleteImageProperty(img: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this._server.postServer('PropertyImageDelete/' + img.id, img).then(
        (resp: any) => {
          resolve(resp);
        }, (error: any) => {
          reject(error);
        }
      );
    });
  }

  realEstateSubscriptions(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this._server.getServer('getSubscriptionsRealEstate/' + id).then(
        (resp: any[]) => {
          resolve(resp);
        }, (err: any) => {
          reject(err);
        }
      );
    });
  }

  getPDF(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._server.getFile('propertyInventory').then(
        (resp: any[]) => {
          resolve(resp);
        }, (err: any) => {
          reject(err);
        }
      );
    });
  }
}
